export default (msg, ...rest) => {
  // This will make it so it only logs these while in development
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(`%c[Chat] ${msg}`, 'color: gray', ...rest)
  }
}
